// @flow
import React, { useRef } from 'react';
import { connect } from 'react-redux';
import IdleTimer from 'react-idle-timer';

import { resetTimer, purgeData } from '../../redux/timer';

import { PURGE_TIMEOUT, IDLE_TIMEOUT } from '../../constants';

const TimerInitializer = ({ timer, reset }) => {
  const idleTimer = useRef(null);
  let isIdle = false;

  const shouldPurge = () => {
    const timeToPurge = PURGE_TIMEOUT - (new Date().getTime() - timer.start);

    if (timeToPurge <= 0) {
      reset();
    } else {
      setTimeout(() => {
        if (isIdle) {
          reset();
        }
      }, timeToPurge);
    }
  };

  const onIdle = () => {
    isIdle = true;
    shouldPurge();
  };

  const onActive = () => {
    isIdle = false;
  };

  shouldPurge();

  return (
    <>
      <IdleTimer
        ref={ref => {
          idleTimer.current = ref;
        }}
        element={document}
        onIdle={onIdle}
        onActive={onActive}
        debounce={250}
        timeout={IDLE_TIMEOUT}
      />
    </>
  );
};

const mapStateToProps = state => ({
  timer: state.timer,
});

const mapDispatchToProps = (dispatch: Function) => ({
  reset: () => {
    dispatch(purgeData);
    dispatch(resetTimer);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TimerInitializer);
